<template lang="pug">
  div
    .main-block.-answers-analytics
      Select.-answers-analytics__item.search(
        placeholder="Выберите курс"
        v-model="course"
      )
      Search.-answers-analytics__item( v-model="search" @params="searchData")
      InputDate.search.-answers-analytics__item(v-model="date" range)
      //- Button.-answers-analytics__item.-answers-analytics__item-button(
      //-   @click="loadCSV"
      //- )
      //-   | Выгрузить данные

    template( v-if="!gettingValidators")
      PageScroll(
        v-if="validatorsList.length > 0"
        :data="validatorsList"
        :isLoading="gettingValidators"
      )
        TableRow(
          v-for="item in validatorsList"
          :key="item.user"
          :validator="item"
        )
      TableEmpty.-answers-analytics-empty( v-else )
    template( v-else)
      SkeletonRow(v-for="i in 3" :key="i")

</template>
<script>
import { mapState } from 'vuex';
import SkeletonRow from './components/SkeletonRow';
import TableRow from './components/TableRow';
import Search from './components/components/Search';
import Select from './components/components/Select';
import replaceMultipleRouteQuery from '@/functions/replaceMultipleRouteQuery';

export default {
  components: {
    SkeletonRow,
    TableRow,
    Search,
    Select
  },
  data() {
    return {
      course: '',
      date: [],
      search: '',
      name: '',
      metaFirstTime: {
        course: true,
        date: true
      }
    };
  },
  computed: {
    ...mapState('answersAnalyticsValidators', {
      validatorsList: s => s.data.validatorsList,
      gettingValidators: s => s.meta.gettingValidators,
      gettingValidatorsCSV: s => s.meta.gettingValidatorsCSV
    })
  },
  watch: {
    '$route.query': function (val) {
      if (val.date_start && val.date_end) {
        this.date = [val.date_start, val.date_end];
      }
    },
    date() {
      if (!this.metaFirstTime.date) {
        this.replaceRoute({
          date_start: this.date[0],
          date_end: this.date[1]
        });
      } else {
        this.metaFirstTime.date = false;
      }
    },
    course() {
      if (!this.metaFirstTime.course) {
        this.replaceRoute({ course: this.course.id });
      } else {
        this.metaFirstTime.course = false;
      }
    }
  },
  mounted() {
    this.date = [this.$route.query.date_start, this.$route.query.date_end];
    this.search = this.$route.query.name;
    this.course = this.$route.query.course;
  },
  destroyed() {
    this.$store.dispatch('answersAnalyticsValidators/setData', {
      path: 'validatorsList',
      value: []
    });
    this.$store.dispatch('answersAnalyticsValidators/setData', {
      path: 'users',
      value: []
    });
    this.$store.dispatch('answersAnalyticsValidators/setData', {
      path: 'tariffs',
      value: []
    });
  },
  methods: {
    searchData(value) {
      if (!value) {
        value = undefined;
      }
      this.name = value;
      this.replaceRoute({ name: this.name });
    },
    replaceRoute({
      date_start = this.date[0],
      date_end = this.date[1],
      course = this.course,
      name = this.name
    }) {
      const arr = [
        {
          name: 'date_start',
          value: date_start,
          method: 'replace'
        },
        {
          name: 'date_end',
          value: date_end,
          method: 'replace'
        },
        {
          name: 'course',
          value: course,
          method: 'replace'
        },
        {
          name: 'name',
          value: name,
          method: 'replace'
        }
      ];

      replaceMultipleRouteQuery(arr);
    }
  }
};
</script>
